module.exports = __webpack_public_path__ + "img/bed-triple.ed3174ce.jpeg";